// Catálogo de textos de la interfaz (es-AR, voseo). Ayuda cita estas mismas claves (UX-P33).
// Los textos con {staff}, {client}… se completan con el vocabulario del rubro (`withVocab` de @/lib/format).

/** Nombre del producto: una sola constante (UX-P32). */
export const PRODUCT_NAME = 'Atte';

export const t = {
  common: {
    cancel: 'Cancelar',
    save: 'Guardar',
    saveChanges: 'Guardar cambios',
    discard: 'Descartar',
    back: 'Volver',
    close: 'Cerrar',
    retry: 'Reintentar',
    retryNow: 'Reintentar ahora',
    loading: 'Cargando…',
    copy: 'Copiar',
    download: 'Descargar',
    print: 'Imprimir',
    goToAgenda: 'Ir a la agenda',
    logout: 'Salir',
    underConstruction: 'En construcción',
  },
  nav: {
    agenda: 'Agenda',
    caja: 'Caja',
    clientes: 'Clientes',
    'gift-cards': 'Gift cards',
    stock: 'Stock',
    comisiones: 'Comisiones',
    finanzas: 'Finanzas',
    tablero: 'Tablero',
    ajustes: 'Ajustes',
    ayuda: 'Ayuda',
    more: 'Más',
    publicPage: 'Página pública',
    myAccount: 'Mi cuenta',
    mainNav: 'Navegación principal',
  },
  userMenu: {
    theme: 'Tema',
    themeLight: 'Claro',
    themeDark: 'Oscuro',
    themeSystem: 'Según el sistema',
    bookingSound: 'Sonido de reservas',
    loggedOut: 'Saliste de Atte.',
  },
  roles: {
    owner: 'Dueño/a',
    manager: 'Encargado/a',
    staff: '{Staff}',
  },
  errors: {
    network: 'No hay conexión. Revisá internet y probá de nuevo.',
    internal: 'Algo salió mal. Probá de nuevo en un momento.',
    unavailable: 'El sistema está ocupado. Probá de nuevo en unos segundos.',
    rateLimited: 'Hiciste muchos pedidos seguidos. Esperá un momento y probá de nuevo.',
    sessionExpired: 'Tu sesión venció. Volvé a entrar.',
    forbiddenAction: 'No tenés permiso para hacer esto. Si creés que es un error, hablá con el dueño/a.',
    moduleOffLive: 'Ese módulo se apagó recién.',
    noAccessSection: 'No tenés acceso a {section}.',
    noAccessLocation: 'No tenés acceso a este local.',
    timeout: 'El servidor no responde.',
  },
  boot: {
    opening: 'Abriendo Atte…',
    failedTitle: 'No pudimos abrir Atte',
    offline: 'No hay conexión a internet.',
    serverDown: 'El servidor no responde.',
    autoRetry: 'Volvemos a probar solos cada 10 segundos.',
  },
  connection: {
    offline: 'Sin conexión. Reintentando…',
  },
  notices: {
    demo: 'Atte de demostración: clientes, ventas y teléfonos son de ejemplo.',
    viewAs: 'Estás viendo Atte como {name} ({role}). No se puede guardar nada.',
    viewAsBack: 'Volver a mi vista',
  },
  notFound: {
    title: 'No encontramos esta página',
    description: 'Puede que el enlace esté mal escrito o que la página ya no exista.',
  },
  serverError: {
    title: 'Algo salió mal',
    description: 'Tuvimos un problema al mostrar esta pantalla. Probá de nuevo; si sigue pasando, avisanos.',
    reload: 'Recargar la página',
  },
  moduleOff: {
    title: '{module} está apagado',
    owner: 'Prendelo en Ajustes › Módulos. Lo que ya cargaste sigue guardado.',
    ownerAction: 'Ir a Módulos',
    others: 'Pedile al dueño/a que lo prenda.',
  },
  bell: {
    title: 'Reservas online',
    emptyTitle: 'No hay reservas nuevas',
    emptyText: 'Cuando alguien reserve o cancele desde la página pública, lo vas a ver acá al instante.',
    markAll: 'Marcar todo como visto',
    markedAll: 'Listo, todas vistas',
    seeAll: 'Ver todas',
  },
  placeholder: {
    title: 'En construcción',
    description: 'Esta sección todavía se está armando. Muy pronto vas a poder usarla desde acá.',
  },
} as const;

/** Reemplaza `{clave}` por valores: fill('Hola {name}', { name: 'Ana' }). */
export function fill(template: string, values: Record<string, string | number>): string {
  return template.replace(/\{(\w+)\}/g, (m, k: string) => (k in values ? String(values[k]) : m));
}
